import { createHash } from 'crypto'

const GA_SALT_CODE = '84B03D034B409D4E'

const generateSha256forGA = (string) => {
    if (string && string !== '') {
        let value = string.replace(/[^\d]+/g, '')
        let valueWithSalt = value + GA_SALT_CODE
        return createHash('sha256').update(valueWithSalt).digest('hex')
    }

    return null
}

export const getURL = (url) => {
    switch (url) {
        case 'bradesco':
            return 'bradesco'
        case 'bancodobrasil':
            return 'bb'
        case '':
            return 'alelo'
        default:
            return 'error'
    }
}

export const sendEvent = (event) => {
    let dataLayer = window['dataLayer']
    dataLayer.push(event)
}

export const baseInteraction = (cpf = null, cnpj = null) => ({
    env_type: 'alelo:b2b',
    app_name: 'loja-web',
    hash_cpf: generateSha256forGA(cpf),
    hash_cnpj: generateSha256forGA(cnpj),
    num_ec: null
})
